import { tools } from '@worktango/ai-assistant/react';
import { fetchCurrentAccountQuery } from '~/behaviors/react-query/account';
import { fetchFindSurveysQuery } from '~/behaviors/react-query/reporting';
import { fetchBasicSurveyListQuery } from '~/behaviors/react-query/survey';
import { reportingStatusIds } from '~/config/settings/survey.settings';

export const listRelatedReportingSurveysTool = tools.createTool({
  name: 'list_related_reporting_surveys',
  description:
    'List all reporting surveys related to a survey type or a survey (through its survey type). It needs at least one of the two parameters to be provided.',
  displayName: 'Finding related surveys',
  pastTenseDisplayName: 'Found related surveys',
  parameters: (t) =>
    t.Object({
      surveyTypeId: t.Optional(
        t.Number({
          description: 'The survey type id to list surveys for',
        }),
      ),
      surveyId: t.Optional(
        t.Number({
          description: 'The survey id to list surveys for',
        }),
      ),
    }),
  fulfill: async (input) => {
    let { surveyTypeId, surveyId } = input;

    if (!surveyTypeId && !surveyId) {
      return JSON.stringify({ error: 'No survey type or survey id provided' });
    }

    const { company } = await fetchCurrentAccountQuery();

    const hasSurveyId = !!surveyId;
    const hasSurveyTypeId = !!surveyTypeId;

    if (!hasSurveyTypeId && hasSurveyId) {
      const surveys = await fetchFindSurveysQuery([surveyId]);

      if (surveys.length === 0) {
        return JSON.stringify({ error: 'Survey not found' });
      }

      surveyTypeId = surveys?.[0]?.types?.[0]?.id;

      if (!surveyTypeId) {
        return JSON.stringify({ error: 'Survey type not found' });
      }
    }

    const surveys = await fetchBasicSurveyListQuery(company.id);

    const surveysBySurveyType = surveys.filter((survey) => {
      const isDifferentSurvey = survey.id !== surveyId;
      const isSurveyTypeMatch = survey.surveyTypeId === surveyTypeId;
      const isReportingStatus = reportingStatusIds.includes(survey.surveyStatusId);

      return isDifferentSurvey && isSurveyTypeMatch && isReportingStatus;
    });

    return JSON.stringify(surveysBySurveyType);
  },
});
